import React  from 'react';
import {
  Card,
  CardBody, CardFooter, Row, Col } from "reactstrap";
  
import { Link } from 'react-router-dom';
var Utils = require ('Utils');
var Const = require ('Const');

const defaultImage = 'https://alumni-images.s3.us-east-2.amazonaws.com/subjects/icons8-estante-de-libro-50.png';

const SubjectCard = ( { subject, openSetup, auditEvals, deleteSubject } ) =>  {
        return (
          <Card>
          <CardBody>
            <Row>
              <Col md="3" xs="3">
                 <img className="imagen" src={subject.image?subject.image:defaultImage} alt={subject.image} />
              </Col>
              <Col md="7" xs="7">
                <div className="caja-materia">
                  <p className="materia">{Utils.capitalize(subject.long_name)}</p>
                  <div className="teachers">
                  { subject.teachers.map( (teacher, idx ) => {
                      return (
                        <div key={teacher.persona_id}>
                         { idx>0 && <br /> } 
                         { Utils.capitalize( teacher.name + " " + teacher.last_name ) + " " } 
                         { subject.teachers.length>1 && teacher.tenured==='1' && "(Tit)"}
                        </div>
                      )
                      }
                    )
                    }
                    {subject.teachers.length===0&&
                      <span style={{color: "red"}}>-sin profesor-</span>
                      }
                  </div>
                 
                </div>
              </Col>
              <Col md="1" xs="1">
                   <Link to="#"
                            onClick={() => { openSetup( true )  }}
                          >
                      <i className="fa fa-edit" />
                    </Link>
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            { auditEvals &&  <a href={"/admin/my-courses/"+subject.course_subject_id+"/calif"}>Revisar calificaciones</a>
            }
            <hr />
            <div className="horarios">
              <i className="fa fa-calendar" />
                { subject.schedule.map( (sch, idx) => {
                  return ( (idx>0?" - ":"") + Const.WEEK_DAYS_SHORT[sch.week_day-1] + " de " + sch.start_time.slice(0,5) 
                            + " a " + sch.end_time.slice(0,5) )
                  }
                )
                }
            </div>
            <hr />
            <Link to="#" onClick={() => { deleteSubject( true )  }}  style={{fontSize: "10px", color: "red"}}>
                      Eliminar Materia </Link>
          </CardFooter>
        </Card>

            )
  };

export { SubjectCard } ;
